import { inject, Injectable } from '@angular/core';
import { AuthApiService } from './auth.service';
import { AuthSessionRedirectService } from '../auth/auth-session-redirect.service';

/**
 * Coordinates sign-out: calls backend, then clears storage/profile and navigates to sign-in.
 */
@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  private readonly authApi = inject(AuthApiService);
  private readonly sessionRedirect = inject(AuthSessionRedirectService);

  /** Fire-and-forget API logout; always clear local session and go to sign-in. */
  signOut(): void {
    this.authApi.adminLogout().subscribe({
      next: () => {
        this.finishSignOut();
      },
      error: () => {
        this.finishSignOut();
      },
    });
  }

  private finishSignOut(): void {
    this.sessionRedirect.redirectToLogin();
  }
}
